import { Dropdown, Modal, Col, Row, Space, Typography, message } from "antd";
import { useState } from "react";
import { Guid } from "guid-typescript";
import { SearchQuery } from "../code/search-query/search-query";
import Loader from "../controls/Loader";
import TemplatesEventsView from "../components/TemplatesEventsView";
import TemplatesEventsFormDialog from "../components/TemplatesEventsFormDialog";
import { TemplateEvent } from "../repository/data.default";
import { getTemplatesEventsExport } from "../repository/data.repository";
import { TemplateEventsForm } from "../components/TemplatesEventsFormDialog.default";
import { useSelector } from "../store/store";
import { authorizeSelectors } from "../store/authorize";
import { getProblemMessage } from "../utils/http";

function TemplatesEventsPage() {
  const [modal, contextHolder] = Modal.useModal();
  const [searchQuery, setSearchQuery] = useState<SearchQuery>({
    conditions: [],
  });
  const [templateEventInputMode, setTemplateEventInputMode] = useState<
    "add" | "update" | "delete"
  >("add");
  const [templateEventInputOpen, setTemplateEventInputOpen] = useState(false);
  const [templateEventInputValues, setTemplateEventInputValues] =
    useState<TemplateEventsForm>({} as any);
  const [triggerView, setTriggerView] = useState(Guid.create().toString());
  const permissions = useSelector(authorizeSelectors.permissions);

  function onSearch(searchQuery: SearchQuery): void {
    setSearchQuery(searchQuery);
  }

  function onTemplateEventAction(
    mode: "add" | "update" | "delete",
    values?: TemplateEvent,
  ): void {
    setTemplateEventInputMode(mode);
    setTemplateEventInputOpen(true);
    setTemplateEventInputValues(
      values
        ? {
            uid: values.uid,
            rowVersion: values.rowVersion,
            template: {
              display: values.templateName,
              value: values.templateUid,
            },
            isActive: values.isActive,
            event: {
              display: values.event,
              value: values.event,
            },
          }
        : ({} as any),
    );
  }

  function onTemplateEventInputFinish(): void {
    setTemplateEventInputOpen(false);
    setTriggerView(Guid.create().toString());
  }

  function onTemplateEventInputClose(): void {
    setTemplateEventInputOpen(false);
  }

  function onDownloadExport(): void {
    const loading = modal.info({
      content: (
        <Typography.Text className="m-1 ml-2 inline-block">
          Downloading template events export file..
        </Typography.Text>
      ),
      footer: null,
      centered: true,
      icon: <Loader />,
    });
    getTemplatesEventsExport({
      searchQuery,
      pageNumber: 0,
      pageSize: Number.MAX_SAFE_INTEGER,
    })
      .then(() => {
        loading.destroy();
      })
      .catch((err) => {
        loading.destroy();
        message.error(getProblemMessage(err) || "Failed to download export.");
      });
  }

  return (
    <Col className="relative flex flex-auto flex-col overflow-hidden overflow-y-auto">
      <Row className="sticky top-0 z-10 flex flex-row flex-wrap items-center p-4">
        <Typography.Title className="m-0 flex-auto" level={4}>
          Triggers
        </Typography.Title>
        <Space className="flex flex-row">
          <Dropdown.Button
            type="primary"
            disabled={!permissions.can("TemplatesEvents", "create")}

            className={`${!permissions.can("TemplatesEvents", "create") ? "disabled" : ""}`}
            menu={{
              items: [
                {
                  key: "downloadExport",
                  label: "Export to Excel",
                  disabled: !permissions.can("TemplatesEvents", "view"),
                  onClick: onDownloadExport,
                },
              ],
            }}
            onClick={() => onTemplateEventAction("add")}
          >
            Add Trigger
          </Dropdown.Button>
        </Space>
      </Row>
      <Col className="flex flex-auto flex-col overflow-hidden p-4 pb-4 pt-0">
        <TemplatesEventsView
          trigger={triggerView}
          onAction={(key: string, record: any) =>
            onTemplateEventAction(key as any, record)
          }
          onSearch={onSearch}
        />
      </Col>
      <TemplatesEventsFormDialog
        key={templateEventInputMode}
        mode={templateEventInputMode}
        open={templateEventInputOpen}
        initialValues={templateEventInputValues}
        onFinish={onTemplateEventInputFinish}
        onCancel={onTemplateEventInputClose}
      />
      {contextHolder}
    </Col>
  );
}

export default TemplatesEventsPage;
